import { createFileRoute } from '@tanstack/react-router';
import ServicesListPage from '@/pages/services/services-list-page';

export const Route = createFileRoute('/_protected/services/')({
  component: ServicesListPage,
});
